import { Chip } from '@mui/material'
import { useStore } from '~/state/useStore'

export function AdminBadge() {
  const role = useStore((s) => s.auth.user?.role)
  if (role !== 'app_admin') return null
  return <Chip label="Admin" size="small" color="secondary" />
}
